import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ButtonForm, ErrorForm, InputLogin } from '../../components'
import { useForm, Controller } from 'react-hook-form'
import { useYupValidation } from '../../hooks'
import { resetPasswordSchema } from '../../yup'
import { IAuthResetPassword } from '../../interfaces'
import logo from '../../assets/images/logo.png'
import { errorHandler } from '../../services'
import { AuthService } from '../../services/index'
import { toast } from 'react-toastify'

export default function ResetPassword(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const location = useLocation()
    const navigate = useNavigate()
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthResetPassword>({
        resolver: useYupValidation(resetPasswordSchema),
    })

    async function sendResetPassword(values: IAuthResetPassword): Promise<void> {
        setIsLoading(true)
        try {
            const data = await AuthService.sendResetPassword({
                ...values,
                code: location.state.code,
                email: location.state.email,
            })
            toast(data.message, { type: 'success' })
            navigate('/')
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div id="reset-password__form">
            <div className="reset-password__backgound">
                <div className="reset-password__content">
                    <div className="reset-password__images">
                        <img src={logo} alt="Logo CNA construtora" className="reset-password__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Redefina sua senha</h4>
                    <form className="reset-password__inputs" onSubmit={handleSubmit(sendResetPassword)}>
                        <Controller
                            name="password"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return <InputLogin placeholder="Nova Senha" type="password" name="password" value={value} onChange={onChange} />
                            }}
                        />
                        <Controller
                            name="passwordConf"
                            control={control}
                            defaultValue={''}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputLogin
                                        type="password"
                                        placeholder="Confirmação da nova Senha"
                                        name="passwordConf"
                                        value={value}
                                        onChange={onChange}
                                    />
                                )
                            }}
                        />
                        <ErrorForm error={errors?.password?.message ? errors.password.message : errors.passwordConf?.message} />
                        <div className="box-button-reset-password">
                            <ButtonForm type={'button'} placeholder="Cancelar" onClick={() => navigate('/login')} />
                            <ButtonForm isLoading={isLoading} type={'submit'} placeholder="Alterar Senha" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
